<template>
    <div>
        <header style="background:#ffffff">
            <div class="p-2 ml-2">
                <div class="header-section d-flex justify-content-between">
                    <div class="header-logo d-flex align-items-center">
                    <h2>
                        <router-link to="/">
                          <img src="../assets/images/bloom_logo.svg" style="width:100%; height:100%"/>
                        </router-link>
                    </h2>
                    </div>
                </div>
            </div>
            <div class="full-container" style="background-color: #006C6B;height:50px;">
            </div>
            <Loader v-if="loading"/>
            <div class="content container mt-4" v-else>
                <div class="text-content" style="font-weight: 500;font-size: 18px;">
                    <p v-html="unSubText"></p>
                </div>
            </div>
        </header>
    </div>
</template>
<script>
import Loader from '../components/Loader.vue';
export default {
  name: 'profileHeader',
  components: { Loader },
  data(){
    return {
        loading: false
    }
  },
  computed: {
    unSubText(){
        return (
        "運営事務局からのお知らせメールを「受け取らない」設定に変更しました。<br>" +
        "※ 登録企業からのメールは「受け取らない」設定はできません。運営事務局にて登録企業からの連絡を代行する場合もあります。<br>" +
        "※ 重要なお知らせは設定に関わらず送信することがあります。"
      );
    }
  },
  methods: {
    async checkUnsub(){
        try {
            this.loading = true;
            console.log(`${process.env.VUE_APP_API}/${this.$route.params.id}/unsubscribe`);
            const unsub = await this.axios({
                method: 'post',
                url: `${process.env.VUE_APP_API}/${this.$route.params.id}/unsubscribe`
            });
            this.loading = false;
        } catch (err){
            console.log(err);
            this.loading = false;
        }
    }
  },
  async created(){
    await this.checkUnsub();    
  }
};
</script>
<style>
</style>

